module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clienteleDetile"
  }, [_c('div', {
    staticClass: "clienteleDetile-con"
  }, [_c('div', {
    staticClass: "clienteleDetile-box"
  }, [_c('div', {
    staticClass: "box-top clearfix"
  }, [_c('div', {
    staticClass: "box-top-title cp"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/clientele"
    }
  }, [_vm._v("客户案例")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.detileData.title))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-con"
  }, [_c('div', {
    staticClass: "con-title clearfix"
  }, [_c('h1', {
    staticClass: "con-title-name"
  }, [_vm._v(_vm._s(_vm.detileData.title))]), _vm._v(" "), _c('div', {
    staticClass: "con-title-read"
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.detileData.view))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "dispaly": "inline-block",
      "padding-bottom": "3px"
    },
    attrs: {
      "src": require("../../assets/img/clientele/imgTwo.png"),
      "alt": _vm.detileData.title
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "con-describe"
  }, [_c('div', {
    staticClass: "con-describe-span"
  }, [_vm._v(_vm._s(_vm.detileData.xiangq_describe))]), _vm._v(" "), _c('div', {
    staticClass: "con-describe-div clearfix"
  }, [_c('div', {
    staticClass: "describe-div-img"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.$global.globalPath + _vm.detileData.xiangq_logo),
      expression: "$global.globalPath + detileData.xiangq_logo"
    }],
    staticStyle: {
      "width": "174px",
      "height": "80px"
    },
    attrs: {
      "alt": _vm.detileData.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "describe-div-title"
  }, [_c('div', {
    staticClass: "describe-title-top"
  }, [_vm._v("公司名称")]), _vm._v(" "), _c('div', {
    staticClass: "describe-title-botton"
  }, [_vm._v(_vm._s(_vm.detileData.title))])]), _vm._v(" "), _c('div', {
    staticClass: "describe-div-title"
  }, [_c('div', {
    staticClass: "describe-title-top"
  }, [_vm._v("应用产品")]), _vm._v(" "), _c('div', {
    staticClass: "describe-title-botton"
  }, [_vm._v(_vm._s(_vm.detileData.xiangq_product))])]), _vm._v(" "), _c('div', {
    staticClass: "describe-div-title"
  }, [_c('div', {
    staticClass: "describe-title-top"
  }, [_vm._v("所属行业")]), _vm._v(" "), _c('div', {
    staticClass: "describe-title-botton"
  }, [_vm._v(_vm._s(_vm.detileData.industry_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "con-detlie",
    domProps: {
      "innerHTML": _vm._s(_vm.detailContent)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-bottom"
  }, [_c('div', {
    staticClass: "box-bottom-wire"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button demo",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDig(("clientele-detile-" + (_vm.$route.query.id)))
      }
    }
  }, [_vm._v("方案详情")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button consult",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.goConsult
    }
  }, [_vm._v("在线咨询")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-bottom-title"
  }, [_c('span', [_vm._v("了解甄云如何变革您的采购业务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-bottom-tel"
  }, [_c('span', [_vm._v("咨询热线：400-116-0808")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60b4f860"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clientele/clienteleDetile.vue
// module id = 658
// module chunks = 12